import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { CheckCircle2, Lock } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { money } from "../../lib/helpers";
import { Button } from "../../components/ui/button";
import PublicFrame, { usePublicBranding } from "./PublicFrame";

export default function PayLink() {
  const { token } = useParams();
  const [params] = useSearchParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  usePublicBranding(data);
  useEffect(() => {
    let tries = 0, timer;
    const load = () => api.get(`/public/pay/${token}`).then((r) => {
      setData(r.data);
      if (params.get("done") && r.data.status === "open" && tries++ < 10) timer = setTimeout(load, 3000);
    }).catch((e) => setError(errMsg(e)));
    load();
    return () => clearTimeout(timer);
  }, [token, params]);
  const pay = async () => {
    setBusy(true);
    try { const r = await api.post(`/public/pay/${token}/checkout`); window.location.assign(r.data.url); }
    catch (e) { setError(errMsg(e)); setBusy(false); }
  };
  if (!data) return (
    <PublicFrame>
      {error ? <div data-testid="pay-error"><h1 className="text-3xl font-bold mb-2">Payment link unavailable</h1>
        <p className="text-muted-foreground">{error}. Please contact the clinic for a new link.</p></div> : <p>…</p>}
    </PublicFrame>
  );
  return (
    <PublicFrame branding={data.branding}>
      <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground">Payment</p>
      <h1 className="text-4xl sm:text-5xl font-bold mt-2" data-testid="pay-amount">{money(data.amount, data.currency)}</h1>
      <p className="text-muted-foreground mt-2 mb-8" data-testid="pay-description">{data.description}</p>
      {data.status === "paid" && <div className="flex items-center gap-3 rounded-[var(--radius)] border border-emerald-500/30 bg-emerald-500/10 p-4 text-emerald-800" data-testid="pay-paid-banner"><CheckCircle2 className="h-5 w-5" />Payment received. Thank you!</div>}
      {data.status === "cancelled" && <p data-testid="pay-cancelled">This payment link is no longer valid. Please contact the clinic.</p>}
      {data.status === "open" && <>
        {params.get("done") && <p className="text-sm text-muted-foreground mb-4" data-testid="pay-checking">Checking your payment…</p>}
        <Button size="lg" className="rounded-full" disabled={busy} data-testid="pay-now-btn" onClick={pay}><Lock className="h-4 w-4 mr-2" />{busy ? "Opening secure payment…" : "Pay securely with SumUp"}</Button>
        {error && <p className="text-sm text-destructive mt-3" data-testid="pay-error">{error}</p>}
      </>}
    </PublicFrame>
  );
}
